import { useEffect } from 'react';
import './App.css';
import PackageJson from '../package.json';
import {
  createBrowserRouter,
  RouterProvider,
} from "react-router-dom";
import AuthGuard from './components/guard/AuthGuard';
import RouteGuard from './components/guard/RouteGuard';
import LoginPage from './container/login';
import PageNotFound from './container/404';
import AthenaSettings, { AthenaSettingsKeys } from './utils/athena_settings';
import Header from './components/Header';
import JobCyclePage from './container/job_cycle';

//Prevent print
document.addEventListener("keydown", function(event) {
  if (event.ctrlKey && event.key === "p") {
    event.preventDefault();
  }
});

export const RouterRoutes = {
  login: '/login',
  jobCycle: '/jobcycle'
}

const router = createBrowserRouter([
  {
    path: RouterRoutes.login,
    element: <LoginPage />,
  },
  {
    path: "/",
    element: <AuthGuard element={<Header />} />,
    children: [
      {
        path: RouterRoutes.jobCycle,
        element: <RouteGuard element={<JobCyclePage />} />
      }
    ]
  },
  {
    path: '*',
    element: <PageNotFound />
  }
]);

function App() {
  useEffect(() => {
    checkCache();
  }, []);

  const checkCache = () => {
    const settings = new AthenaSettings();
    if (settings.value?.version !== PackageJson.version) {
      if ('caches' in window) {
        caches.keys().then((names) => {
          names.forEach(name => {
            caches.delete(name);
          });
        });

        window.location.reload(true);
      }

      settings.setItem(AthenaSettingsKeys.version, PackageJson.version);
    }
  };
  
  return (
    <RouterProvider router={router} />
  );
}

export default App;
